import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./EventList.scss";

const EventList = ({ events }) => {
  const date = new Date(useSelector(state => state.date));
  const weekDay = ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"];


    return (
      <>
        {date && (
          <h1 className="date">
            {weekDay[date.getDay()] +
              " " +
              date.getDate() +
              "/" +
              (date.getMonth() + 1)}
          </h1>
        )}
        {events.length === 0 ? (
          <h3>Det finns inga händelser att visa idag</h3>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Namn</th>
                <th>Plats</th>
                <th>Tid</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {events.map(event => {
                return (
                  <tr key={event.id}>
                    <td>
                      <Link to={"/event/" + event.id}>{event.name}</Link>
                    </td>
                    <td>
                      {event.address}, {event.city}
                    </td>
                    <td>{event.starttime.substr(0, 5)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </>
    );
}

EventList.propTypes = {
  events: PropTypes.array.isRequired,
  date: PropTypes.string
};

export default EventList;
